import { useEffect, useState } from "react";
import "./TermsPage.css";
import TopPanel from './components/TopPanel';
import Footer from './components/Footer';
import { termsContent } from './termsContent';

const TermsPage = () => {
  const [activeSection, setActiveSection] = useState("");

  const sections = termsContent.map(s => ({ id: s.id, title: s.navTitle }));

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = sections.map(s => document.getElementById(s.id));
      const scrollPosition = window.scrollY + 200;

      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const element = sectionElements[i];
        if (element && element.offsetTop <= scrollPosition) {
          setActiveSection(sections[i].id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="terms-page">
      <div className="landing-header-wrapper">
        <TopPanel />
      </div>
      <div className="terms-page__container">
        <nav className="terms-page__nav">
          <h3 className="terms-page__nav-title">Contents</h3>
          {sections.map(section => (
            <button
              key={section.id}
              className={`terms-page__nav-item ${activeSection === section.id ? 'active' : ''}`}
              onClick={() => scrollToSection(section.id)}
            >
              {section.title}
            </button>
          ))}
        </nav>
        <div className="terms-page__content-wrapper">
          <h1 className="terms-page__main-title">Affiliate Program Terms & Conditions</h1>
          
          <div className="terms-page__content">
            <p>This Affiliate Agreement is entered into between <strong>WinningPartner</strong> and the party whose legal name is set out in the applicable affiliate application, insertion order, commercial agreement, or account registration, hereafter referred to as <strong>"you"</strong>, <strong>"your"</strong>, or <strong>"Affiliate"</strong>.</p>

            <p>WinningPartner owns and operates the Affiliate Program, whereby approved third-party commercial partners may refer individuals to the appropriate websites, brands, platforms, or applications operated by WinningPartner, the Group, or associated companies.</p>

            <p>By registering for the Affiliate Program, accessing any affiliate platform, using any tracking link, promoting any Group Property, accepting any commission, or otherwise participating in the Affiliate Program, the Affiliate confirms that it has read, understood, and agreed to this Agreement.</p>

            <p>WinningPartner may modify this Agreement at any time. Where practical, WinningPartner may notify the Affiliate of such changes. Continued participation in the Affiliate Program after any modification shall constitute acceptance of the updated Agreement.</p>

            {termsContent.map(section => (
              <div key={section.id}>
                <h2 id={section.id} className="terms-page__title">{section.title}</h2>
                {section.paragraphs.map((p, i) => (
                  <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsPage;
